const tpl = (fields) => ({ page: 'skills', ...fields })

export const SKILL_TEMPLATES_PART01 = [
  tpl({
    id: 'demo-tpl-skl-battlecard',
    title: 'Competitive battlecard',
    category: 'Sales',
    apps: ['Web research', 'HubSpot'],
    description: 'A one-page battlecard against any competitor: where we win, where we lose, and what to say.',
    steps: ['Research the competitor’s product, pricing, and positioning', 'Mine HubSpot for deals won and lost against them', 'Write talk tracks and landmines'],
    skill: {
      instructions: `**For the competitor named:**

1. Summarise their product, pricing model, and target customer, with sources.
2. Pull HubSpot deals from the last 12 months where they were listed as a competitor; note win rate and the stated reasons.
3. Write **Where we win**, **Where we lose**, and **Landmines to set** — three bullets each.
4. End with two discovery questions that expose their weak spots.`,
      examples: ['Build a battlecard against ThoughtSpot', 'How do we beat Hex in a deal?'],
    },
  }),
  tpl({
    id: 'demo-tpl-skl-cold-email',
    title: 'Cold email first draft',
    category: 'Sales',
    apps: ['Web research', 'Gmail'],
    description: 'A short, specific first email built from something real about the prospect.',
    steps: ['Find one recent, specific fact about the prospect', 'Tie it to a problem we solve', 'Draft a sub-120-word email in Gmail'],
    skill: {
      instructions: `**For the person and company named:**

1. Find one specific, recent hook: a launch, a hire, a post they wrote, or a funding round.
2. Connect it to one problem we solve, in their words rather than ours.
3. Draft an email under 120 words: hook, problem, one proof point, a low-effort ask.
4. Save it as a Gmail draft — never send it.`,
      examples: ['Draft a cold email to the Head of Data at Canva', 'Write an intro email to Priya Nair at Zepto'],
    },
  }),
]
